import request from "utils/request";

import { baseRequestURL } from "api/BaseAPI";

const ACCOUNT = "ACCOUNT";
const JOB = "JOB";
const TRAINING_DATA = "TRAINING";
const JOB_TEMPLATE = "JOB_TEMPLATE";
const GUIDED_BLUEPRINT = "GUIDED_BLUEPRINT";
const DEPLOYMENT = "DEPLOYMENT";
const RECIPE = "RECIPE";
const MODEL_RUN = "MODEL_RUN";

export function createNameFromJobId(jobId) {
  return "test1ModelGroup_" + jobId;
}

export function getTagByName(tagName) {
  return request(baseRequestURL + "v1/tag/" + encodeURIComponent(tagName), {
    method: "GET"
  }).then((response) => response);
}

/*
export function getTags() {
  return request(baseRequestURL + "v1/tag/test1ModelGroup_1014", {
    method: "DELETE"
  }).then(response => response);
}
*/

export function getTags() {
  return request(baseRequestURL + "v1/tags/", {
    method: "GET"
  }).then((response) => response);
}

export function createTag(tagName, value = "") {
  return request(baseRequestURL + "v1/tags", {
    method: "POST",
    body: JSON.stringify({
      name: tagName,
      value: value
    })
  }).then((response) => response);
}

export function addDatasetToTag(tagName, id) {
  return request(baseRequestURL + "v1/tagged", {
    method: "POST",
    body: JSON.stringify({
      name: tagName,
      type: "training_data",
      id: id
    })
  }).then((response) => response);
}

export function deleteDatasetFromTag(tagName, id) {
  return request(baseRequestURL + "v1/tagged/" + tagName, {
    method: "DELETE",
    body: JSON.stringify({
      type: "training_data",
      id: id
    })
  }).then((response) => response);
}

export function getDatasetTags(id) {
  return request(baseRequestURL + "v1/tags/by/training_data/" + id, {
    method: "GET"
  }).then((response) => response);
}

export function getAllDatasetTags() {
  return request(baseRequestURL + "v1/tags/by/training_data", {
    method: "GET"
  }).then((response) => response);
}
